export default __webpack_public_path__ + "static/media/euro.de1b64cd.svg";